import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { Box } from '@mui/material';
import {
  LoanEditorSection,
  SectionVisibility,
} from 'app/pages/programs/channels/Channels.constants';
import PropTypes from 'prop-types';

import { selectChannelSectionVisibilityMap } from 'store/loanApplications/selectors';

import { disabledWrapperStyles } from '../AutoLockSubsection/AutoLockSubsection.styles';

/**
 * Applies the active channel's per-section visibility to a loan-editor surface that is NOT a
 * standalone nav tab (Pricing lives inside Property & Loan; Conditions inside Underwriting), so the
 * nav-tab drop in LoanNavigationTabs cannot reach it. Hidden removes the surface; Read-only renders
 * it non-interactive via the same disabled-wrapper the auto-lock engine uses.
 */
const ChannelSectionGate = ({ section, children }) => {
  const visibilityMap = useSelector(selectChannelSectionVisibilityMap);
  const visibility = visibilityMap[section];

  if (visibility === SectionVisibility.HIDDEN) {
    return null;
  }

  if (visibility === SectionVisibility.READ_ONLY) {
    return (
      <Box aria-disabled sx={disabledWrapperStyles}>
        {children}
      </Box>
    );
  }

  return children;
};

ChannelSectionGate.propTypes = {
  section: PropTypes.oneOf(Object.values(LoanEditorSection)).isRequired,
  children: PropTypes.node,
};

export default memo(ChannelSectionGate);
